import { HashLocationStrategy, PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import config from '../public/innovacare-clinical/public-seo.config.json';

export function isPublicMarketingPath(url: string): boolean {
  const pathname = url.split(/[?#]/)[0].replace(/\/+$/, '');
  return config.pages.some((page) => page.path === pathname);
}

/** Clean URLs for the public site; retain the existing hash URLs for every other workspace. */
@Injectable()
export class PublicMarketingLocationStrategy extends HashLocationStrategy {
  constructor(private readonly platform: PlatformLocation) {
    super(platform, '/');
    const legacy = platform.hash.replace(/^#/, '');
    if (isPublicMarketingPath(legacy))
      platform.replaceState(platform.getState(), '', legacy);
  }
  override path(includeHash = false): string {
    const hash = super.path(includeHash);
    if (this.platform.hash.startsWith('#/')) return hash;
    if (isPublicMarketingPath(this.platform.pathname))
      return this.platform.pathname + this.platform.search;
    return hash;
  }
  override prepareExternalUrl(internal: string): string {
    if (internal === '/' || internal === '' || isPublicMarketingPath(internal))
      return internal || '/';
    // A bare hash would retain the current public pathname on navigation.
    return '/' + super.prepareExternalUrl(internal).replace(/^\//, '');
  }
}
